import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import LoadingState from './LoadingState';

export const PrivateRoute = () => {
  const { session, loading } = useAuth();

  // Show loading state while determining authentication status
  if (loading) {
    return <LoadingState />;
  }

  // Redirect to login if not authenticated
  return session ? <Outlet /> : <Navigate to="/login" replace />;
};
